import { ElementRef } from '@angular/core';

const TWO_DIRECTIONS = ['ArrowUp', 'ArrowDown'];
const FOUR_DIRECTIONS = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];

export const arrowNavigationHandler = (
  parentElement: ElementRef,
  childrenSelector: string,
  event: KeyboardEvent,
  directions: 'two' | 'four' = 'two'
) => {
  const arrowKeys = directions === 'four' ? FOUR_DIRECTIONS : TWO_DIRECTIONS;
  if (arrowKeys.includes(event.key)) {
    const focusableElements = getFocusableElements(parentElement, childrenSelector);
    const focusedElement = <HTMLElement>document.activeElement;
    if (!parentElement.nativeElement.contains(focusedElement)) {
      return;
    }
    handleArrowKey(event, focusableElements, focusedElement);
  }
};

const getFocusableElements = (parentElement: ElementRef, selector: string) => {
  return <HTMLElement[]>Array.from(parentElement.nativeElement.querySelectorAll(selector));
};

const handleArrowKey = (event: KeyboardEvent, focusableElements: HTMLElement[], focusedElement: HTMLElement) => {
  const index = focusableElements.indexOf(focusedElement);
  const isOpen = focusedElement.querySelectorAll('ul, li').length > 1;
  event.preventDefault();

  switch (event.key) {
    case 'ArrowRight':
      !isOpen && focusedElement.click();
      break;
    case 'ArrowLeft':
      isOpen && focusedElement.click();
      break;
    case 'ArrowDown':
      focusNextElement(focusableElements, index);
      break;
    case 'ArrowUp':
      focusPreviousElement(focusableElements, index);
      break;
  }
};

const focusNextElement = (focusableElements: HTMLElement[], currentIndex: number) => {
  const nextIndex = currentIndex + 1 >= focusableElements.length ? 0 : currentIndex + 1;
  focusableElements[nextIndex].focus();
};

const focusPreviousElement = (focusableElements: HTMLElement[], currentIndex: number) => {
  const previousIndex = currentIndex - 1 < 0 ? focusableElements.length - 1 : currentIndex - 1;
  focusableElements[previousIndex].focus();
};
